import Accordion from "react-bootstrap/Accordion";
import { ChevronDown, Telephone, Building } from "react-bootstrap-icons";
import { BsPersonVcard } from "react-icons/bs";
import Button from "react-bootstrap/Button";
import { SlScreenSmartphone } from "react-icons/sl";
import { GiHomeGarage } from "react-icons/gi";
import React, { useCallback, useEffect, useState } from "react";
import { AddDriver } from "./AddDriver";
import { Loader } from "../common/Loader";
import { getDriversList } from "../../services/Networkcall";
import { errorAlert } from "../common/Alert";
import { Image } from "react-bootstrap";
import { HiOutlineMail } from "react-icons/hi";

const DriverSection = ({
  selectedDriver,
  setSelectedDriver,
  mode = "single",
  selectedMultipleDrivers = [],
  setMultipleDrivers = () => { },
  editMode = false

}) => {

  const [loading, setLoading] = useState(false);
  const [driverList, setDriverList] = useState([])
  const [activeKey, setActiveKey] = useState(null);
  const [refetch, setRefetch] = useState(false);

  const [show, setShow] = useState(false);

  // ===============DRIVERS LIST======================
  const fetchDriversList = async () => {
    setLoading(true);
    try {
      const res = await getDriversList();
      if (res?.success) {
        setDriverList(res?.data || [])
      } else {
        errorAlert({ message: res?.message })
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || "Something went wrong." })
    } finally {
      setLoading(false);
    }
  }


  // ===============SELECT DRIVER SINGLE OR MULTI AND CLOSE ACCORDION======================
  const handleDriverSelect = useCallback((driver) => {
    if (mode === "multiple") {
      const exists =  selectedMultipleDrivers.find(d => d._id === driver._id);
      if (exists) {
        setMultipleDrivers( selectedMultipleDrivers.filter(d => d._id !== driver._id));
      } else {
        setMultipleDrivers([...selectedMultipleDrivers, driver]);
      }
      return;
    }

    // single select mode
    setSelectedDriver(driver);
    setActiveKey(null);

  }, [mode,selectedMultipleDrivers,setSelectedDriver,setMultipleDrivers]);


  // ===============CLOSE ADD DRIVER MODAL======================
  const handleCloseModal = () => {
    setShow(false);
    fetchDriversList();
  }

  // ===============EFFECTS======================
  useEffect(() => {
    fetchDriversList();
  }, []);

  
  useEffect(() => {
    if(refetch){
      fetchDriversList();
      setRefetch(false);
    }
  }, [refetch]);



  return (
    <>
      <Loader show={loading} />
      <Accordion className="rb-accordion mb-3" activeKey={activeKey}
        onSelect={(eventKey) =>
          setActiveKey(activeKey === eventKey ? null : eventKey)
        }>

        <Accordion.Item eventKey="0" className="driver-card p-0">

          {/* 🔥 HEADER */}
          <Accordion.Header className="driver-acc-header">

            <div className="header-wrapper">

              {/* TOP ROW */}
              <div className="driver-header-top">
                <div className="left">
                  <BsPersonVcard size={24} color="#2563eb" />
                  <span>Driver</span>
                </div>

                {!editMode && (
                  <div
                    className="add-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShow(true);
                    }}
                  >
                    + Add Driver
                  </div>
                )}
                </div>

                {/* 🔹 Driver  BOX */}
                {selectedDriver?._id ?
                  <div className="driver-box">
                    <Image src={selectedDriver?.profileImage || "assets/images/placeholder.png"} width={25} height={25} className="rounded object-fit-fill" />

                    {/* ICON BOX */}
                    <div className="info">
                      <h6>{selectedDriver?.userName}</h6>
                      <p className="mb-0"><HiOutlineMail size={14} color="#000" /> {selectedDriver?.email}</p>
                      <p> <SlScreenSmartphone size={14} color="#000" /> {selectedDriver?.phoneNumber} </p>
                    </div>


                    {/* RIGHT */}
                    <div className="right">
                      <span className="selected">Selected ✓</span>
                      <ChevronDown className="arrow-icon" />
                    </div>

                  </div>
                  :
                  <div className="vehicle-box">
                    <strong>Please select driver</strong>
                    <div className="right">
                      <ChevronDown className="arrow-icon" />
                    </div>
                  </div>
                }

              </div>

          </Accordion.Header>

          {/* 🔥 BODY */}
          <Accordion.Body>
            <div className="diver-body">
              {(driverList && driverList.length > 0) ?
                (driverList.map((driver, idx) => (
                  <div className="driver-box cursor-pointer mb-2" key={driver?._id} onClick={() => handleDriverSelect(driver)}>

                    <Image src={driver?.profileImage || "assets/images/placeholder.png"} width={25} height={25} className="rounded object-fit-fill" />


                    {/* INFO */}
                    <div className="info">
                      <h6>{driver?.userName}</h6>
                      <p className="mb-0 text-break"><HiOutlineMail size={14} color="#000" /> {driver?.email}</p>
                      <p> <SlScreenSmartphone size={14} color="#000" /> {driver?.phoneNumber} </p>
                    </div>

                    {/* RIGHT */}
                    {(mode === "multiple"
                      ?  selectedMultipleDrivers.some(d => d._id === driver._id)
                      : selectedDriver?._id === driver?._id) &&
                      <div className="right">
                        <span className="selected">Selected ✓</span>
                      </div>
                    }

                  </div>
                ))
                ) : (
                  <div className="vehicle-body text-center">
                    <p className="mb-0 mt-2">No Driver Found</p>
                  </div>
                )}

            </div>
          </Accordion.Body>

        </Accordion.Item>

      </Accordion>
      {show && <AddDriver show={show} closeModal={handleCloseModal} setRefetch={setRefetch} />}
    </>);
}

export default React.memo(DriverSection);